export const UPDATE = "exist/update"
export const ADD = "new/add"

export const toogleUpdate = (id) =>{
    return{
        type: UPDATE,
        payload: id
    }
}

export const toogleAdd = () =>{
    return {
        type: ADD,
    }
}